import type { FieldBoundaryProperties } from './field-boundary.types';

/** Maps payload `unit_type` + `unit_id` to derived geo id properties (access-key GUID strings). */
export function applyUnitDerivedProperties(props: FieldBoundaryProperties): void {
    const unitType = props.unit_type?.trim().toLowerCase();
    const unitId = props.unit_id?.trim();
    if (!unitType || !unitId) return;

    switch (unitType) {
        case 'country':
            props.country_id = unitId;
            break;
        case 'region':
            props.region_id = unitId;
            break;
        case 'city':
            props.city_id = unitId;
            break;
        case 'district':
            props.district_id = unitId;
            break;
        default:
            break;
    }
}

/** True when decoded features use string access keys for geo ids (GeographicUnitPayload). */
export function usesStringGeoIds(props: FieldBoundaryProperties): boolean {
    if (props.unit_type?.trim()) return true;
    return (
        typeof props.country_id === 'string' ||
        typeof props.region_id === 'string' ||
        typeof props.city_id === 'string' ||
        typeof props.district_id === 'string'
    );
}
